import styled from 'styled-components';
import {accentColorPrim, accentColorTertiary, bpMd, red, white} from "../../assets/styledAssets/vars";
import {Dialog} from "@progress/kendo-react-dialogs";
import * as CSS from 'csstype';

interface BtnProps {
  primary: boolean
  accent: boolean
}

export const ComponentDialogBody = styled.div`
  flex-grow:1;
  overflow-y:auto;
  padding:0 3rem;
`;

export const StyledModalAction = styled.button<Partial<CSS.Properties & BtnProps>>`
    display:flex;
    align-items:center;
    justify-content: center;
    font-size:1.6rem;
    border:0;
    background-color:${white};
    padding:1.6rem;
    min-height:4.4rem;
    flex-grow:1;
    cursor:pointer;
    &:not(:last-child){
        border-right:1px solid ${accentColorTertiary};
    }
    &:hover{
      background-color: ${accentColorTertiary};
    }
    &:focus{
      outline:none;
    }
    ${props=> props.primary ? `color: ${red};` : (props.accent ?  `color: ${accentColorPrim};` : `color:#000;`)}
`;

export const StyledDialog = styled(Dialog)`
    .k-dialog{
        box-shadow: 0 0 2rem 1rem rgba(0, 0, 0, .08);
        position:fixed;
        top: 6rem;
        bottom:0;
        right:0;
        width: 100%;
        max-width: 100%;
        border-top-left-radius: 1.2rem;
        border-top-right-radius: 1.2rem;
        @media(min-width: ${bpMd}) {
          max-width: 45rem;
          top:0;
          border-top-left-radius: 0;
          border-top-right-radius: 0;
        }
    }
    .k-content{
        padding:5rem 0 0;
        display:flex;
        flex-direction:column;
    }
    .k-overlay{background-color:transparent;}
`;

export const StyledDialogActionsBar = styled.div`
    display:flex;
    border-top: 1px solid ${accentColorTertiary};  
    button{flex-grow:1}
`;